import { render, staticRenderFns } from "./BuserUserList.vue?vue&type=template&id=05c6fcec&scoped=true&"
import script from "./BuserUserList.vue?vue&type=script&lang=js&"
export * from "./BuserUserList.vue?vue&type=script&lang=js&"
import style0 from "./BuserUserList.vue?vue&type=style&index=0&id=05c6fcec&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c6fcec",
  null
  
)

export default component.exports